import { MethodApiId } from '../data/methods';

export const connectorMethodApiMap: Record<string, MethodApiId> = {
  metamask: MethodApiId.Metamask,
  walletconnect: MethodApiId.WalletConnect,
};
